// AUTO-GENERATED from docs/TECHNICAL_PRD.md — CID Agent PWA API layer
// Module: Co-Agency / Referral Letters
// Every list (collection GET) takes params { page, limit, ...filters }.
import client from './client';

/**
 * GET /api/agent/co-agency-letters [LIST · paginated]
 * List the caller agent's own co-agency/referral letters with status filter, search and pagination (the my-letters inbox).
 * @disposition ADAPT_SCOPE · maps to GET /admin/co-agency-letters (coAgencyLetter.service.listLetters)
 */
export const listCoAgencyLetters = (params = {}) => client.get(`/api/agent/co-agency-letters`, { params });

/**
 * GET /api/agent/co-agency-letters/:id
 * Full letter detail (all snapshot fields) + status timeline for tracking, edit prefills and client-side preview/render.
 * @disposition ADAPT_SCOPE · maps to GET /admin/co-agency-letters/:id (getLetterById)
 */
export const getCoAgencyLettersById = (id, params = {}) => client.get(`/api/agent/co-agency-letters/${id}`, { params });

/**
 * POST /api/agent/co-agency-letters
 * Create a new letter as a private draft (status -> PENDING) — nobody verifies it; the
 * agent issues it themselves when the terms are settled. letter_ref auto-generated.
 * @disposition ADAPT_SCOPE · maps to POST /admin/co-agency-letters (createLetter, creatorType param)
 */
export const createCoAgencyLetters = (data = {}) => client.post(`/api/agent/co-agency-letters`, data);

/**
 * PUT /api/agent/co-agency-letters/:id
 * Edit a draft letter. Refused once issued — the terms it states are then the terms.
 * @disposition ADAPT_SCOPE · maps to PUT /admin/co-agency-letters/:id (updateLetter)
 */
export const updateCoAgencyLettersById = (id, data = {}) => client.put(`/api/agent/co-agency-letters/${id}`, data);

/**
 * POST /api/agent/co-agency-letters/:id/issue
 * Put the agent's own draft letter into force (PENDING -> issued). Drops the watermark
 * from its PDF and makes it selectable on a sale. There is no verifier.
 * @disposition ADAPT_SCOPE · maps to POST /admin/co-agency-letters/:id/issue (issueLetter)
 */
export const createCoAgencyLettersIssueById = (id, data = {}) => client.post(`/api/agent/co-agency-letters/${id}/issue`, data);

/**
 * POST /api/agent/co-agency-letters/:id/signed-document
 * Upload the counter-signed / executed copy (PDF or image) once the co-agency returns it.
 * @disposition ADAPT_SCOPE · maps to POST /admin/co-agency-letters/:id/signed-document (uploadSignedDocument)
 */
// Signed executed-copy: upload-url → PUT to storage → confirm (public 'co-agency-letters' bucket).
export const createCoAgencyLettersSignedDocumentById = (id, data = {}) => client.post(`/api/agent/co-agency-letters/${id}/signed-document/upload-url`, data);
export const createCoAgencyLettersSignedDocumentConfirmById = (id, data = {}) => client.post(`/api/agent/co-agency-letters/${id}/signed-document/confirm`, data);

/**
 * DELETE /api/agent/co-agency-letters/:id/signed-document
 * Remove/replace the uploaded counter-signed executed copy.
 * @disposition ADAPT_SCOPE · maps to DELETE /admin/co-agency-letters/:id/signed-document (removeSignedDocument)
 */
export const deleteCoAgencyLettersSignedDocumentById = (id, config = {}) => client.delete(`/api/agent/co-agency-letters/${id}/signed-document`, config);

/**
 * GET /api/agent/co-agency-letter-settings [LIST · paginated]
 * Read-only HQ letterhead/template config (letter_body_template, company_logo_url, license_logo_url, company_chop_url, signatory_signature_url, signatory name/title, etc.) so the PWA renders the live preview and the verified letter client-side.
 * @disposition ADAPT_SCOPE · maps to GET /admin/co-agency-letter-settings (coAgencyLetterSettings.getSettings)
 */
export const listCoAgencyLetterSettings = (params = {}) => client.get(`/api/agent/co-agency-letter-settings`, { params });

/**
 * GET /api/agent/co-agency-letters/:id/pdf [LIST · paginated]
 * View/download the rendered (verified) letter as a canonical PDF. Optional — only if a server-authoritative PDF is required rather than an in-app client render.
 * @disposition BUILD_NEW
 */
export const listCoAgencyLettersPdf = (id, params = {}) => client.get(`/api/agent/co-agency-letters/${id}/pdf`, { params });
